import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { askQuestion } from '../api';

export default function QuestionForm() {
  const { t, lang } = useLanguage();
  const [body, setBody] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');
    try {
      const res = await askQuestion({ body, email: email || undefined, language: lang });
      setStatus('done');
      setMessage(res.message || '');
    } catch (err) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  if (status === 'done') {
    return (
      <div className="form__done" role="status">
        <b><span className="tick">✓</span> {t('form.thanksTitle')}</b>
        <p style={{ opacity: 0.85 }}>{message || t('form.thanksBody')}</p>
      </div>
    );
  }

  return (
    <form className="form" onSubmit={submit} noValidate>
      <textarea
        className="textarea"
        required
        placeholder={t('ask.placeholder')}
        value={body}
        onChange={(e) => setBody(e.target.value)}
        disabled={status === 'loading'}
        style={{ minHeight: 120 }}
      />
      <input
        className="input"
        type="email"
        placeholder={t('hero.email') + ' (optional)'}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        aria-label="Email address (optional)"
        disabled={status === 'loading'}
      />
      <button className="btn btn--primary" type="submit" disabled={status === 'loading'}>
        {status === 'loading' ? '…' : t('ask.submit')}
      </button>
      {status === 'error' && <p className="form__msg form__msg--err">{message}</p>}
    </form>
  );
}
